import { Route } from "react-router-dom";
import { WebsiteDemoWidgetRoute } from "../../../../../../routes/widget-route/subroutes/website-demo-widget-route/website-demo-widget-route";

export const WidgetRoutes = (
    <>
        <Route path="website-demo" element={<WebsiteDemoWidgetRoute />} />
    </>
)